import { Button, type ButtonProps } from '@mui/material'
import React from 'react'

import { StyledRouterLink } from 'components/common/StyledRouterLink'
import Icon from 'components/Icon'
import { getTestSuitesUrls } from 'components/test-suites/test-suites-urls-utils'
import { useTranslation } from 'hooks/use-translation'
import { type TestSuite } from 'types/api/test-suites/test-suites'

export const CloneTestSuiteButton: React.FC<{
  buttonProps?: ButtonProps
  testSuite: TestSuite
}> = ({ buttonProps, testSuite }) => {
  const { trans } = useTranslation()
  const testSuitesUrls = getTestSuitesUrls()

  return (
    <Button
      component={StyledRouterLink}
      data-test-test-suite-clone-button={testSuite.identifier}
      data-track-action="clone-test-suite"
      data-track-category="test-suites"
      data-track-on="click"
      size={buttonProps?.size ?? 'small'}
      startIcon={<Icon icon="clone" />}
      state={{
        testSuite: { ...testSuite, identifier: null, isOfficial: false }
      }}
      to={testSuitesUrls.new()}
      variant={buttonProps?.variant ?? 'contained'}
    >
      {trans('clone')}
    </Button>
  )
}
